module.exports = __webpack_public_path__ + "img/4.d0d4401b.png";